import type {
  IxdMatchPreviewResult,
  WorkbookTablePreviewResult,
} from "@/apis/ixd-value-sync/types";

/**
 * preview 캐시에서 워크북 표 (tableId, roleKey) 하나의 current/prior만 갈아 끼운다.
 *
 * tableName·labelKo·tocId·isPeriodEnd·isThreeMonthAcc·taggedPeriods 같은 매칭 유래 메타는 표별 응답에 없으므로 그대로 둔다.
 * 같은 role을 가진 다른 표가 있을 수 있어 roleKey만으로 고르지 않는다.
 */
export const replaceWorkbookTable = (
  preview: IxdMatchPreviewResult,
  tableId: string,
  roleKey: string,
  tables: WorkbookTablePreviewResult,
): IxdMatchPreviewResult => ({
  ...preview,
  entries: preview.entries.map((entry) =>
    entry.workbook?.tableId === tableId && entry.workbook.roleKey === roleKey
      ? {
          ...entry,
          workbook: {
            ...entry.workbook,
            current: tables.current,
            prior: tables.prior,
          },
        }
      : entry,
  ),
});
